<div class="avatar-container" [ngStyle]="hostStyle">

    <div class="avatar-content" [ngStyle]="avatarStyle">
        {{ avatarText }}
    </div>

</div>
